import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import tw from "twin.macro";
import { GenerateLink } from "../utils/generateLinks";

const Envelope = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		stroke-width="1.5"
		stroke="currentColor"
		class="size-6"
	>
		<title>Envelope</title>
		<path
			stroke-linecap="round"
			stroke-linejoin="round"
			d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
		/>
	</svg>
);

const Phone = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		strokeWidth={1.5}
		stroke="currentColor"
		className="size-6"
	>
		<title>Phone</title>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z"
		/>
	</svg>
);

const FooterWrapper = tw.section`
bg-primary text-white py-16 font-sans
`;

const FooterContainer = tw.div`
container grid md:grid-cols-3 text-sm
`;

const MenuWrapper = tw.div`
flex flex-col text-sm mb-8 lg:mb-0
`;

const ContactArea = tw.div`
flex flex-col py-6
`;

const ContactText = tw.p`
ml-3
`;

const ContactMethod = tw.div`
  flex text-sm font-bold items-center mb-6 font-sans
`;

const SectionHeader = tw.p`
  font-bold mb-3
`;

const CertificationArea = tw.div`
  grid grid-cols-2 gap-4
  `;

const CertificationImage = tw.img`
  w-24
  `;

const CertificationLink = tw.a`
    flex items-center justify-center
  `;

export const Footer = () => {
	const query = useStaticQuery(graphql`
    query GetFooter {
      sanityMenu {
        item {
          _key
          label
          childpages {
            slug {
              current
              _type
            }
          }
        }
      }
      sanityCompany {
        address1
        address2
        city
        country
        email
        name
        phone
        postcode
        certifications {
          image {
            asset {
              url
            }
          }
          pdf {
            asset {
              url
            }
          }
        }
      }
    }
  `);

	const P = tw.p`font-sans leading-normal pb-2`;

	const {
		sanityCompany: {
			address1,
			address2,
			city,
			country,
			email,
			phone,
			postcode,
			name,
			certifications,
		},
		sanityMenu,
	} = query;
	return (
		<FooterWrapper>
			<FooterContainer>
				<MenuWrapper>
					<SectionHeader>Menu</SectionHeader>
					{sanityMenu.item.map(({ label, childpages, _key }) => (
						<GenerateLink
							theme={"dark"}
							link={childpages[0].slug}
							NoPadding={true}
							key={_key}
						>
							{label}
						</GenerateLink>
					))}
				</MenuWrapper>
				<div>
					<SectionHeader>Address</SectionHeader>
					<P>{name}</P>
					<P>{address1}</P>
					<P>{address2}</P>
					<P>{city}</P>
					<P>{postcode}</P>
					<P>{country}</P>
				</div>
				<ContactArea>
					<ContactMethod>
						<phone />
						<ContactText>{phone}</ContactText>
					</ContactMethod>
					<ContactMethod>
						<envelope />
						<ContactText>{email}</ContactText>
					</ContactMethod>
					<CertificationArea>
						{certifications.map((cert) => (
							<CertificationLink
								href={cert.pdf.asset.url}
								rel="nofollow"
								target="_blank"
								key={cert.image.asset.url}
							>
								<CertificationImage src={cert.image.asset.url} alt="" />
							</CertificationLink>
						))}
					</CertificationArea>
				</ContactArea>
			</FooterContainer>
		</FooterWrapper>
	);
};
